import React from 'react'
import Link from 'next/link'
import {Trans} from "@lingui/react/macro";

const PageTitle = (props) =>
{
    if(props?.context?.render === "embed"){
        return null
    }

    return(
        <div className="wpo-breadcumb-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-breadcumb-wrap">
                            {!props.hideTitle &&(
                                <h2>{props.title}</h2>
                            )}

                            <ul>
                                <li><Link href={props.context.org.BASE_WEB_URL}><Trans>Accueil</Trans></Link></li>
                                {props.broadcamp && props.broadcamp.map(i=>{
                                    return(
                                        <li><Link href={i.url}>{i.label}</Link></li>
                                    )
                                })}
                                <li><span>{props.title}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageTitle;
